import { useTranslation } from 'react-i18next';

export default function Process() {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('process1_title'),
      description: t('process1_desc'),
      icon: 'ri-map-pin-line'
    },
    {
      number: '02',
      title: t('process2_title'),
      description: t('process2_desc'),
      icon: 'ri-settings-3-line'
    },
    {
      number: '03',
      title: t('process3_title'),
      description: t('process3_desc'),
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('process_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('process_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-all duration-300 h-full border border-gray-100">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-5xl font-bold text-[#1e3a8a]/10">
                    {step.number}
                  </span>
                  <div className="w-14 h-14 flex items-center justify-center bg-[#1e3a8a] rounded-lg">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-[#1e3a8a]/30"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
